export default "__VITE_ASSET__oHaLbTtz__"